import { Navbar, Container, Nav } from 'solid-bootstrap';
import { LogoutButton } from '../logout/logoutbutton';

export function TCNavbar(props) {
    return <Navbar bg="primary" variant="dark" class="min-vh-2">
        <Container>
            <Navbar.Brand href="/"><img src="/assets/img/hands.png" class="brand-mascot" /> Timechief</Navbar.Brand>
            <Nav class="ml-auto">
                <LogoutButton />
            </Nav>
        </Container>
    </Navbar>
}